export const AutoCapabableDevices = ['NAC', 'BAC'];
